import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css'; // Optional: Import CSS for styling

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-columns">
          <div className="footer-column">
            <h4>Legal</h4>
            <nav className="footer-nav">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-of-service">Terms of Service</Link>
              <Link to="/refund-policy">Refund Policy</Link>
              <Link to="/disclaimer">Legal Disclaimer</Link>
            </nav>
          </div>
          
          <div className="footer-column">
            <h4>Company</h4>
            <nav className="footer-nav">
              <Link to="/about-us">About Us</Link>
              <Link to="/contact-us">Contact Us</Link>
            </nav>
          </div>
          
          <div className="footer-column">
            <h4>Comparisons</h4>
            <nav className="footer-nav">
              <Link to="/comparison/explanatum-vs-ideabuddy">Explanatum vs IdeaBuddy</Link>
              <Link to="/comparison/explanatum-vs-bizplan">Explanatum vs Bizplan.com</Link>
              <Link to="/comparison/explanatum-vs-canvanizer">Explanatum vs Canvanizer</Link>
            </nav>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© 2025 Explanatum Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
